import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import uuid from 'uuid';
import { theme } from 'styles';

const Wrapper = styled.label`
  user-select: none;
  cursor: pointer;

  * {
    user-select: none;
  }

  input {
    opacity: 0;
    width: 0;
    height: 0;

    &:checked + span {
      background-color: ${theme.colors.green};

      &::after {
        left: 39px;
        background-color: ${theme.colors.white};
      }
    }
  }

  input[disabled] + span {
    cursor: default;
  }

  span {
    display: inline-block;
    position: relative;
    transition: background-color 0.3s;
    border-radius: 12px;
    background-color: ${theme.colors.grey};
    width: 60px;
    height: 24px;
    vertical-align: middle;
    content: '';
    color: tomato;

    &::after {
      display: inline-block;
      position: absolute;
      top: 3px;
      left: 3px;
      transition: left 0.3s ease, background 0.3s ease, box-shadow 0.1s ease;
      border-radius: 21px;
      background-color: ${theme.colors.white};
      width: 18px;
      height: 18px;
      content: '';
    }
  }

  input[disabled] + span::after,
  input[disabled]:checked + span::after {
    background-color: ${theme.colors.offWhite};
  }
`;

const Text = styled.div`
  color: ${theme.colors.white};
  position: absolute;
  top: 2px;
  ${props => (props.isChecked ? 'left: 10px;' : 'right: 13px;')};
`;

const propTypes = {
  name: PropTypes.string.isRequired,
  isChecked: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
};

const defaultProps = {
  isChecked: false,
};

function Switch({ name, isChecked, onToggle }) {
  const id = `${name}-${uuid.v4()}`;

  return (
    <Wrapper htmlFor={id}>
      <input
        id={id}
        type="checkbox"
        className="Switch__Checkbox"
        checked={isChecked || false}
        onChange={onToggle}
      />
      <span>
        <Text isChecked={isChecked}>{isChecked ? 'Yes' : 'No'}</Text>
      </span>
    </Wrapper>
  );
}

Switch.propTypes = propTypes;
Switch.defaultProps = defaultProps;

export default Switch;



// WEBPACK FOOTER //
// ./src/components/shared/Switch/Switch.jsx